import { useEffect, useState } from 'react';

import { ScanIqCustomerSuccessInfo } from '../../../../../interfaces/ScanIqCustomerSuccessInfo';
import { scanIqHomeService } from '../../../../../services/scanIqHomeService';

type UseScanIqCustomerSuccessReturn = {
  customerSuccess: ScanIqCustomerSuccessInfo | null;
};

export const useScanIqCustomerSuccess = (
  entityId: number,
): UseScanIqCustomerSuccessReturn => {
  const [customerSuccess, setCustomerSuccess] =
    useState<ScanIqCustomerSuccessInfo | null>(null);

  const fetchCustomerSuccess = async () => {
    const data = await scanIqHomeService.getCustomerSuccess(entityId);
    setCustomerSuccess(data);
  };

  useEffect(() => {
    fetchCustomerSuccess();
  }, [entityId]);

  return { customerSuccess };
};
